module.exports = __webpack_public_path__ + "static/media/sy.225e72fe.svg";